import React, { Suspense } from "react";
import { Node_Type } from "./../../ricos-types/index.js";
const Button = React.lazy(
  () => import(
    /* webpackChunkName: "ricos_plugin_button_lazy" */
    "./button.js"
  )
);
const ButtonRenderer = ({
  node,
  nodeIndex,
  NodeViewContainer,
  ...props
}) => {
  return /* @__PURE__ */ React.createElement(Button, { node, nodeIndex, NodeViewContainer, ...props });
};
const ButtonLazy = ({ node, ...props }) => {
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: "" }, /* @__PURE__ */ React.createElement(ButtonRenderer, { key: node.id, node, ...props }));
};
const nodeViewRenderers = {
  [Node_Type.BUTTON]: ButtonLazy
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=node-view-renderers-lazy.js.map
